import { useIsOfficeAdmin } from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import { Navigate, Outlet } from "react-router-dom";

export const OfficeAdminRoute = () => {
  const isOfficeAdmin = useIsOfficeAdmin();

  return isOfficeAdmin ? <Outlet /> : <Navigate to="/" replace={true} />;
};
